import { getODataErrors } from '@bingads-webui-campaign/api-errors';

export const generalErrorMessage = _TL_("We've encountered an error and could not finish this task. Please try again or contact support.");
const getDomainsOAuthErrorMessage = _TL_('We weren\'t able to retrieve your purchased domains. Please sign in to your M365 for Business account again.');

export const SmartPageErrorMap = {
  // smart page specific error code mapping, should looks like
  // errorCode: _TL_('error message')),
  GeneralError: generalErrorMessage,
  TimeOut: _TL_('Operation time out. Come back later to edit your website.'),
  SmartPageInvalidStatusForAdd: _TL_('Smart page site has invalid status for adding.'),
  SmartPageSubdomainIsNotAvailable: _TL_('This URL is already in use. Please choose a different one.'),
  SmartPageLimitExceeded: generalErrorMessage,
  SmartPageSiteSuffixAlreadyExists: generalErrorMessage,
  SmartPageMissingSiteSuffix: generalErrorMessage,
  SmartPageListIsNullOrEmpty: generalErrorMessage,
  SmartPageInvalidSiteSuffix: generalErrorMessage,
  SmartPageIsNull: generalErrorMessage,
  SmartPageInvalidStatus: _TL_('Smart page site has invalid status. Please refresh your page and try again.'),
  SmartPageInvalidSubdomain: _TL_('Smart page site has invalid subdomain.'),
  CustomerNotInPilotForSmartPage: _TL_('This customer is not in pilot for smart page.'),
  SmartPageGetFbPageUserError: _TL_('We cannot get Facebook page for this user.'),
  SmartPageGetFbPageApiError: _TL_('We cannot get Facebook page for this user.'),
  SmartPageIdIsInvalid: generalErrorMessage,
  SmartPageConcurrentUpdatingIsNotAllowed: _TL_('Concurrent updating is not allowed.'),
  SmartPageIncompleteInfoProvided: generalErrorMessage,
  SmartPageTableStorageError: _TL_('Storage error.'),
  SmartPageAssociationListIsNullOrEmpty: generalErrorMessage,
  SmartPageAssociationInvalidStatus: generalErrorMessage,
  DuplicateSmartPageAssociation: generalErrorMessage,
  SmartPageAssociationInvalidType: generalErrorMessage,
  SmartPageSubdomainExceedsMaxLength: _TL_('Subdomain exceeds max length.'),
  SmartPageFbImportParamMissing: generalErrorMessage,
  SmartPageFbImportNoTokenFoundInKeyVault: _TL_('We cannot get Facebook page for this user.'),
  SmartPageSubdomainChangeIsNotAllowed: generalErrorMessage,
  SmartPageUrlIsRejectedByEditorial: _TL_('Subdomain is rejected by Editorial.'),
  SmartPageCustomDomainIsNotAvailable: _TL_('This custom domain is already in use with another Smart Page.'),
  SmartPagePreviousCustomDomainIsNotFreedUp: _TL_('It looks like you recently updated your Smart Pages URL. Please wait at least 24 hours before changing your URL again.'),
  SmartPagePreviousSubdomainIsNotFreedUp: _TL_('It looks like you recently updated your Smart Pages URL. Please wait at least 24 hours before changing your URL again.'),
  SmartPageUpdateDomainWithin24HoursNotAllow: _TL_('You updated your Smart Pages URL less than 24 hours ago. Please wait at least 24 hours before making further changes.'),
  SmartPageM365TokenIsNullInKeyVault: getDomainsOAuthErrorMessage,
  SmartPageInvalidM365TokenInKeyVault: getDomainsOAuthErrorMessage,
  SmartPageM365OAuthError: getDomainsOAuthErrorMessage,
  SmartPageM365AdminApiError: generalErrorMessage,
};

export const SmartPageNoLoggingError = {
  SmartPageInvalidSubdomain: true,
  SmartPageConcurrentUpdatingIsNotAllowed: true,
  SmartPageUrlIsRejectedByEditorial: true,
  SmartPageInvalidStatus: true,
};

export const getErrorMessage = (response, i18n) => {
  const generalMessage = i18n.getString(generalErrorMessage);
  let isUserError = false;

  if (!response || !response.errors || response.errors.length < 1) {
    return {
      message: generalMessage,
      isUserError,
    };
  }

  // check smart page specific error map first
  const code = response.errors[0].Code;
  const message = i18n.getString(SmartPageErrorMap[code]);
  if (message) {
    if (SmartPageNoLoggingError[code]) {
      isUserError = true;
    }
    return {
      message,
      isUserError,
    };
  }

  // look up campaign odata error mapping
  const errors = getODataErrors(response.errors, i18n);
  if (errors && errors[0] && errors[0].message) {
    return {
      message: errors[0].message,
      isUserError,
    };
  }

  // fallback to general error message
  return {
    message: generalMessage,
    isUserError,
  };
};
